<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">Smart Cryptocurrency Assistant</h3>
                    <h5 class="fw-bold my-4">Diverse and Specialized Services for the Crypto Market</h5>
                    <h6 class="my-4">Maximize your returns using the most up-to-date solutions</h6>
                    <button class="btn-blue">Free Registration</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-md-9 mx-auto">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <div class="col-lg-7 text-end">
                        <h2 class="fw-bold">Comprehensive and Intelligent Trading Services 💯</h2>
                        <h5 class="mt-3 ps-3" style="line-height: 30px;">
                            Trading is considered one of the most complex tasks. At Bytecal, we have continuously developed and provided services aimed at increasing trading efficiency. Considering the vast and 24/7 nature of the cryptocurrency market, every trader needs an assistant that constantly looks for profitable trading opportunities around the clock.
                        </h5>
                        <button class="btn-blue mt-4">Free Registration</button>
                    </div>
                    <div class="col-lg-5 my-auto text-start">
                        <img src="../../../assets/test/blog1.webp" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-lg-5 my-auto text-end">
                        <img src="../../../assets/test/blog1.webp" class="w-100" alt="">
                    </div>
                    <div class="col-lg-7 text-end">
                        <h2 class="fw-bold">Comprehensive & Smart Trading Services 💯</h2>
                        <h5 class="mt-3 ps-3" style="line-height: 30px;">
                            Trading is arguably one of the most complex tasks. At Bytecal, we have consistently developed and offered services designed to boost your trading performance. Given the vast and 24/7 nature of the cryptocurrency market, every trader needs a smart assistant that actively scans for profitable opportunities around the clock.
                        </h5>
                        <button class="btn-blue mt-4">Sign Up for Free</button>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-lg-7 text-end">
                        <h2 class="fw-bold">Comprehensive and Intelligent Trading Services 💯</h2>
                        <h5 class="mt-3 ps-3" style="line-height: 30px;">
                            Trading is considered one of the most complex tasks. At Bytecal, we have always developed and provided services that help improve trading performance. Given the vast and 24/7 nature of the cryptocurrency market, every trader needs an assistant that constantly searches for profitable trading opportunities around the clock.
                        </h5>
                        <button class="btn-blue mt-4">Free Registration</button>
                    </div>
                    <div class="col-lg-5 my-auto text-start">
                        <img src="../../../assets/test/blog1.webp" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-lg-5 my-auto text-end">
                        <img src="../../../assets/test/blog1.webp" class="w-100" alt="">
                    </div>
                    <div class="col-lg-7 text-end">
                        <h2 class="fw-bold">Comprehensive & Intelligent Trading Services 💯</h2>
                        <h5 class="mt-3 ps-3" style="line-height: 30px;">
                            Trading is arguably one of the most complex activities. At Bytecal, we've continuously developed and delivered solutions designed to maximize trading efficiency. Given the vast and 24/7 nature of the cryptocurrency market, every trader needs a smart assistant—one that works around the clock to identify the best trading opportunities.
                        </h5>
                        <button class="btn-blue mt-4">Register for Free</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px;">
            <div class="row container my-5 py-3 text-end">
                <h3 class="fw-bold">Purchase a Subscription to Access Bytecal’s Advanced Features</h3>
                <h6>Try Bytecal now, and upgrade your plan whenever you need.</h6>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>